import React, { useEffect, useRef } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    width: "100%",
    height: isMobile ? "425px" : "544px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    color: theme.palette.white.main,
    borderRadius: "0px 0px 75px 75px",
    background: `linear-gradient(to top, #252241, #211e3a, #1d1b32, #1a182b, #161424, #161424, #171525, #171525, #1b192d, #1f1d36, #23223f, #272648);`,
    backgroundSize: "cover",
  },
  intro: {
    backgroundColor: theme.palette.white.main,
    height: isMobile ? "198px" : "168px",
    width: isMobile ? "260px" : "80%",
    margin: "-100px 0 0 0",
    boxShadow: "0 4px 100px 0 rgba(199, 206, 211, 0.25)",
    borderRadius: "47px",
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: "center",
    alignItems: "center",
  },
  typography: {
    title: {
      fontFamily: isMobile
        ? theme.typography.montserrat.regular
        : theme.typography.montserrat.light,
      fontSize: isMobile ? 40 : 70,
      lineHeight: "1.15",
      width: isMobile ? "280px" : "700px",
    },
    intro: {
      fontFamily: theme.typography.montserrat.regular,
      fontSize: isMobile ? "23px" : { xs: "23px", md: "25px", xl: "30px" },
      color: theme.palette.blue.main,
      width: isMobile ? "200px" : "fit-content",
    },
  },
});

const HeroSection = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const focusElement = useRef(null);

  const focusOnElement = () => {
    focusElement.current && focusElement.current.scrollIntoView();
  };

  useEffect(() => {
    if (focusElement) {
      focusOnElement();
    }
  }, []);

  const { pathname } = useLocation();
  const { title, subtitle } = useTranslation(pathname, "HeroSection");

  return (
    <>
      <Box sx={classes.container}>
        <Typography sx={classes.typography.title}>
          <b>{title}</b>
        </Typography>
      </Box>
      <Box sx={classes.intro} ref={focusElement}>
        <Typography sx={classes.typography.intro}>
          {subtitle[0]}&nbsp;
        </Typography>
        <Typography sx={classes.typography.intro}>
          <b>{subtitle[1]}</b>
        </Typography>
      </Box>
    </>
  );
};

export default HeroSection;
